import creditCardType, {
  getTypeInfo,
  types as CardType,
} from 'credit-card-type';

export const prettyCardNumber = (cardNumber: string) => {
  const cardType = creditCardType(cardNumber)[0]?.type || CardType.VISA; // default to visa type if unknown

  let prettyCardNumber = cardNumber;

  const typeInfo = getTypeInfo(cardType);

  const gaps = typeInfo.gaps;
  const maxLength = Math.max(...typeInfo.lengths) + gaps.length;

  prettyCardNumber = cardNumber.split('').reduce((acc, digit, i) => {
    if (gaps.includes(i)) acc += ' ';
    acc += digit;
    return acc;
  }, '');

  return prettyCardNumber.slice(0, maxLength);
};
